// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        signedIn: true,
        userObj: action.payload.user,
        userSessionObj: action.payload.user_session,
      }
    case 'LOGOUT':
      return {
        ...state,
        signedIn: false,
        userObj: {},
        userSessionObj: {},
      }
    default:
      return state
  }
}
